import styled from 'styled-components';
import editIcon from 'components/shared/Icon/icons/editIcon.svg';
import { ifProp, palette } from 'styled-tools';

const InfoTableWrapper = styled.div`
  margin-bottom: 1.5rem;
`;

const InfoTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
  table-layout: fixed;
  
  th, td {
    padding: 4px 4px 0 0;
    text-align: left;
    vertical-align: middle;
  }
  
  th {
    font-weight: 500;
    color: #6E7881;
  }
  td {
    color:var(--color-primary);
    border-bottom: 1px solid #D1D7DE;
  }
  
  @media (min-width: 768px) {
    th:nth-child(1), td:nth-child(1) { width: 30%; }
    th:nth-child(2), td:nth-child(2) { width: 35%; min-width: 250px; }
    th:nth-child(3), td:nth-child(3) { width: 30%; }
    th:nth-child(4), td:nth-child(4) { width: 5%; }
  }
  @media (max-width: 450px) {
    th, td {
      padding: 2px 3px;
      text-align: left;
      vertical-align: middle;
    }
    max-width: 270px;
    th:nth-child(1), td:nth-child(1) { width: 25%; }
    th:nth-child(2), td:nth-child(2) { width: 45%; }
    th:nth-child(3), td:nth-child(3) { width: 25%; }
    th:nth-child(4), td:nth-child(4) { width: 5%; }
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 0.25rem 0.5rem;
  font-size: 1rem;
  height: 2.5rem;
  box-sizing: border-box;
  border: 1px solid var(--color-primary);
  border-radius: 4px;
  background: #fff;
    ${(props) => props.invalid && `
    border-color: #a6031f;
    
    &:focus {
      border-color: #a6031f;
      box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
    }
  `}
`;
const RemoveButton = styled.button`
  padding: 0.25rem 0.8rem;
  background: #a6031f;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 0.95rem;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
  &:hover {
    background: #a6031f;
  }
`;

const StyledStateAndLLCButton = styled.button`
  background: transparent;
  border: none;
  color: var(--color-primary);
  font-size: 1rem;
  cursor: pointer;
  text-align: left;
  flex: 1;
  padding: 0;
  position: relative;
  &:hover::after {
    content: ' ';
    position: absolute;
    top: 0;
    background: url(${editIcon}) no-repeat 0 0;
    white-space: nowrap;
    z-index: 10;
    font-style: italic;
    width: 1rem;
    height: 1rem;
    right: -20px
  }
`;

const ErrorMessage = styled.div`
  color: #a6031f;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 0.25rem;
  margin-top: 0.25rem;
`;

const StyledSelect = styled.div`
  font-size: 1rem;
  line-height: 1.42857;
  width: 100%;

  & .react-select__control {
    height: 2.5rem;
    font-weight: normal;
    color: ${palette('primary', 0)};
    background-color: ${palette('white', 0)};
    border: 1px solid ${ifProp('invalid', palette('danger', 0), palette('primary', 0))};
    border-radius: 3px;
    box-shadow: inset 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
    &:hover {
      border-color: ${ifProp('invalid', palette('danger', 0), palette('primary', 1))};
    }
  }

  & .react-select__placeholder {
    color: ${palette('primary', 2)};
  }

  & .react-select__single-value {
    color: ${palette('primary', 2)};
  }

  & .react-select__control--is-disabled {
    cursor: not-allowed;
    background-color: #dadbdb;
    opacity: 1;
  }

  & .react-select__control--is-focused {
    border: 1px solid ${ifProp('invalid', palette('danger', 0), palette('primary', 0))};
    outline: 0;
  }

  & .react-select__menu {
    margin: 3px 0 0;
    font-weight: normal;
    font-size: var(--font-size-base);
  }
  
  & .react-select__option--is-focused {
    background-color: ${palette('primary', 0)};
    color: ${palette('white', 0)};
    &:active {
      background-color: ${palette('primary', 1)};
    }
  }
  
  & .react-select__option--is-selected {
    background-color: ${palette('primary', 1)};
    color: ${palette('white', 0)};
    &:active {
      background-color: ${palette('primary', 1)};
    }
  }
`;

export {
  InfoTableWrapper,
  InfoTable,
  Input,
  RemoveButton,
  StyledStateAndLLCButton,
  ErrorMessage,
  StyledSelect,
};
